import { service as request } from '../utils/request'
// ----------------------------------------------------上传文件
// --------------------------------------------------------------------------------
export function InquireUpload(data) {
    return request.post('/file/business/upload/o_upload', data);
}
// 获取车辆列表
export function getCarList(query) {
    return request({
        url: '/intelligent/vehicleInformation/vehicleInformationListPage', method: 'get',
        params: query,
    })
}
// 获取车辆列表
export function getCarNumber(query) {
    return request({
        url: '/intelligent/vehicleInformation/getNumber', method: 'get',
        params: query,
    })
}

// 提交表单信息
export function imageUpload(data) {
    return request({
        url: '/intelligent/vehicleInformation/imageUpload',
        method: 'post',
        data,
        contentType: "application/json;charset=UTF-8",  //设置JSON字符串格式
    })
}
// 提交表单信息
export function postCarInfo(data) {
    return request({
        url: '/intelligent/vehicleInformation/insertVehicleInformation',
        method: 'post',
        data,
        contentType: "application/json;charset=UTF-8",  //设置JSON字符串格式
    })
}
// 提交表单信息
export function updateCarInfo(data) {
    return request({
        url: '/intelligent/vehicleInformation/updateById',
        method: 'post',
        data,
        contentType: "application/json;charset=UTF-8",  //设置JSON字符串格式
    })
}
// 提交表单信息
export function getwechat(query) {
    return request({
        url: '/wechat/wechat/oauth2',
        method: 'get',
        params: query
    })
}
// 登录方法
export function login(username, password, code, uuid) {
    return request({
        url: '/auth/login', headers: {
            isToken: false
        }, method: 'post', data: { username, password, code, uuid }
    })
}

// 退出方法
export function logout() {
    return request({
        url: '/auth/logout', method: 'delete'
    })
}

// 获取用户详细信息
export function getInfo() {
    return request({
        url: '/system/user/getInfo', method: 'get'
    })
}

// ------------------国五今日累计车辆接口-------------------------------------------------------

export function totalVehicleCountGuoWu(data) {
    return request.get('/intelligent/inandout/totalVehicleCountGuoWu', data);
}

export function totalVehicleCountGuoLiu(data) {
    return request.get('/intelligent/inandout/totalVehicleCountGuoLiu', data);
}

// ------------------24厂区环境变化趋势图与排名 接口-------------------------------------------------------

export function AvgFrontGroupOrder(data) {
    return request.get('/intelligent/ursDataFencheng/AvgFrontGroupOrder', data);
}

// ------------------厂区环境变化趋势图与排名-------------------------------------------------------

export function hourAvgFrontGroupOrder(data) {
    return request.get('/intelligent/ursDataFencheng/hourAvgFrontGroupOrder', data);
}

//
// ----------------------------------------------------空气质量排行---------------------------------------------------------------------------
// //微站、TSP台账排行
export function InquireAirranking(data) {
    return request.get('/intelligent/ursDataFencheng/tspOrVocOrderFront', data);
}

//获取设备在线数量
export function InquireOnlineNum(data) {
    return request.get('/intelligent/device/getDeviceOnlineCountFront', data);
}

// --------------------------------------------------- 排行-- -
// TSP检测排行----------------------------------------------------------

// --------------------------------------------------台账---
// 空气质量微站监测台账--------------------------------------------------------
// 根据多个类型查区域
export function Inquireallarea(data) {
    return request.get('/intelligent/device/getDeviceLabelFront', data);
}

// --------------------------------------------------台账---TSP监测台账------------------------------------------------------


// --------------------------------------------------台账---监测设备运行管理--------------------------------------------------
// 监测设备运行管理
export function getjcsbyxgl(data) {
    return request.get('/intelligent/device/getListDeviceOnlineFront', data);
}

// 实时数据分页查询
export function InquireDetail(data) {
    return request.get('/intelligent/ursDataFencheng/pageFront', data);
}

// --------------------------------------------------报表---省控站--------------------------------------------------
//标准站报表
export function getstandardData(data) {
    return request.get('/intelligent/ursDataFencheng/xingYuanfindAllFront', data);
}

// --------------------------------------------------监控---视频监控--------------------------------------------------
// 设备扩展列表
export function getvideoval(data) {
    return request.get('/intelligent/ursDeviceAll/listFront', data);
}

// 播放视频
export function getnewjkurl(data) {
    return request.get('/intelligent/cameraPrevicew/previewURLsFront', data);
}

// 视频回放
export function gethuifangurl(data) {
    return request.get('/intelligent/cameraPrevicew/playbackURLsFront', data);
}

// --------------------------------------------------台账---洗车机运行台账-------------------------------------------------
// 洗车机洗车总数
export function Inquiresxcjtz(data) {
    return request.get('/intelligent/serviceRack/carWasherCountFront', data);
}

// 雾炮运行时长
export function Inquirewpyxsc(data) {
    return request.get('/intelligent/ursCommandLiandong/toDayAvgFront', data);
}

// 喷淋雾炮区域
export function getdeviceArea(data) {
    return request.get('/intelligent/ursCommandLiandong/getWuPaoPenLinLabelFront', data);
}

// 喷淋运行台账
export function getdevicePage(data) {
    return request.get('/intelligent/ursCommandLiandong/getWuPaoPenLinPageFront', data);
}

// -------------------------------------------------------弹窗
// ---------------------------------------------------------------------------
//洗车机查看详情分页
export function InquireTcData(data) {
    return request.get('/intelligent/findServiceRack/findAllServiceRackPageFront', data);
}


// -------------------------------------------------------
// 雾炮设备运行信号历史---------------------------------------------------------------
//雾炮运行信号历史
export function InquireWpyxls(data) {
    return request.get('/intelligent/ursCommandLiandong/getHistoricalDataWuPaoFront', data);
}

//分页
export function Inquirezlgcpage(data) {
    return request.get('/intelligent/ursCommandLiandong/pageFront', data);
}

//检测设备运行管理顶部数据
export function getjcsbcount(data) {
    return request.get('/intelligent/device/getDeviceCountFront', data);
}

//排放源分页查询
export function InquireEs(data) {
    return request.get('/intelligent/ursSource/ursSourcePageFront', data);
}

//-----------------------------------------------------排放源 -
// 查询排放源基本信息---------------------------------------------------
export function InquirePfymsg(data) {
    return request.get('/intelligent/ursSource/ursFindAllByIdFront', data);
}

// -------------------------------------------------------
// 查询排放源修改专用-----------------------------------------------------------------------
export function Inquire_modify(data) {
    return request.get('/intelligent/ursSource/ursFindAllUpdateByIdFront', data);
}


//请求tsp设备数量
export function gettspnum(data) {
    return request.get('/intelligent/device/getListByTypesFront', data);
}

//查询无组织排放源 治理设备接口
export function getwzczhili(data) {
    return request.get('/intelligent/device/findByTypeFront', data);
}

// ------------------------------------------------------修改排放源
// ----------------------------------------------------------------------------

export function Inquiremodify(data) {
    return request.get('/intelligent/ursSource/ursSourceUpdateFront', data);
}



//
// ------------------------------------------------------删除排放源----------------------------------------------------------------------------

export function Inquire_deletepfy(data) {
    return request.get('/intelligent/ursSource/ursSourceRemoveFront', data);
}


//
//
//
// ----------------------------------------------------新增排放源-----------------------------------------------------------------------------

export function InquireNewAdd(data) {
    return request.get('/intelligent/ursSource/ursSourceAddFront', data);
}



//安智连
export function azliot(data) {
    return request.post('/intelligent/azliot/token', data);
}

// 首页洗车机
export function getxichejimsg(data) {
    return request.get('/intelligent/serviceRack/findCarWasherFront', data);
}

// 首页排放源
export function getfrontpagepfy(data) {
    return request.get('/intelligent/source/sourceTypeCountFront', data);
}

// ---------------------------------------------车辆电子台账 -
// 清洁运输占比-------------------------------------------------------------
export function InquirePercentage(data) {
    return request.get('/intelligent/transportDate/getProportionXingYuanFront', data);
}

//
//
//
// ------------------------------------------------------查询除尘器最后一条数据--------------------------------------------------------------

export function Inquire_DustRlastData(data) {
    return request.get('/intelligent/device/last/theLastTimeDeviceDataFront', data);
}

// ---------------------------------------------------------
// 首页均值折线图--------------------------------------------------------------------
export function Inquirejunzhival(data) {
    return request.get('/intelligent/ursDataFencheng/hourAvgFront', data);
}

// 首要污染物
export function getPollutants(data) {
    return request.get('/intelligent/ursDataFencheng/xingYuanHour24AverageFront', data);
}

// 取地图标注与坐标
export function gettakelatlng(data) {
    return request.get('/intelligent/mapDevice/findMapDeviceFront', data)
}

// 查询设备类型
export function getDeviceType(data) {
    return request.get('/intelligent/device/findDeviceTypeFront', data)
}

// 日数据
export function InquireDetailday(data) {
    return request.get('/intelligent/ursCommandLiandong/dayPageFront', data);
}

// 小时数据
export function InquireDetailhour(data) {
    return request.get('/intelligent/ursCommandLiandong/hourPageFront', data);
}

// 请求所有喷淋
export function getallwl(data) {
    return request.get('/intelligent/device/getListByTypeFront?' + data);
}

// 获取喷淋设备数据
export function getwlequipment(data) {
    return request.get('/intelligent/device/getListByTypeFront?' + data);
}

// 请求雾炮设备数据
export function getwpequipment(data) {
    return request.get('/intelligent/device/getListByTypeFront?' + data);
}

// 查询所有的设备
export function Inquireallequipment(data) {
    return request.get('/intelligent/device/getListByTypeFront', data);
}

// 查询多个设备类型
export function getListByTypes(data) {
    return request.get('/intelligent/device/getListByTypeFront', data)
}

// 分页
export function Inquirelevel(data) {
    return request.get('/intelligent/ursDeviceAlarmBase/pageFront', data);
}

// 车辆电子台账
export function InquireGuoMingcarLedger(data) {
    return request.get('/intelligent/transportDate/cleanCarFront', data);
}

//
//
//
//
// --------------------------------------------场内运输车辆电子台账------------------------------------------------------------------
export function InquireInthefield(data) {
    return request.get('/intelligent/transportDate/internalTransferVehicleXingYuanFront', data);
}

//
//
//
//
// --------------------------------------------非道路移动机械电子台账------------------------------------------------------------------
export function InquireOffroad(data) {
    return request.get('/intelligent/transportDate/factoryTransportVehicleInfoXingYuanFront', data);
}

// ----------------------------------------------车辆进场数量 - 今日累计车辆进场数量------------------------------------------------
export function InquirecarInnum(data) {
    return request.get('/intelligent/inandout/totalVehicleFront', data);
}


// 存经纬度标注
export function getAddlatlng(data) {
    return request.get('/intelligent/mapDevice/mapDeviceInsertFront', data)
}

// 有组织监测--------获取除尘器设备
export function get_ChuchenData(data) {
    return request.get('/intelligent/device/getHistoricalData/findChuChenQiLastDataFront', data);
}

// 有组织监测--------修改治理设备
export function getzhilimodify(data) {
    return request({
        url: '/intelligent/device/getHistoricalData/findChuChenQiUpdateFront', method: 'put', data: data
    })
}

// 有组织监测------有组织数据管理~获取列表

export function getcemspageData(data) {
    return request.get('/intelligent/cecms/getCecmsDeviceLastData', data);
}

// 生产设备数据管理------------ 数据查看
export function Inquirescsbyxfy(data) {
    return request.get('/intelligent/ursDeviceAll/findProductionDeviceLastDataPage', data);
}


// ------------------------------------------------------洗车台 - 查看洗车机照片详情
// ------------------------------------------------------------
export function Inquirexctimg(data) {
    return request.get('/intelligent/findServiceRack/findCarWasherImageFront', data);
}

// 除尘器数据
export function getchuchenqiData(data) {
    return request.get('/intelligent/device/getChuChenQiFront', data)
}

// 有组织数据管理 动态查询设备数据
export function get_Sbvalue_Data(data) {
    return request.get('/intelligent/device/getShengChanJianCeShuJuFront', data);
}

// 删除标注
export function getdelMark(data) {
    return request.get('/intelligent/mapDevice/deleteMapFront', data)
}

// ---------标准站
export function getbzzchartData(data) {
    return request.get('/intelligent/ursDataFencheng/biaoZhunZhanDataFront', data);
}

// ------------------------------------------------------- 未清除
// 清除-------------------------------------------------------------------
export function Clear_Url(data) {
    return request.get('/intelligent/ursDeviceAlarmBase/updateLogFront', data);
}

// 查询地图标注 CEMS、除尘器
export function getmapLabel(data) {
    return request.get('/intelligent/device/getDeviceAllFront', data);
}

// --------------------------------------预警信息-折线图------------------------------------------------------------
export function Inquiresbidval(data) {
    return request.get('/intelligent/ursDeviceAlarm/getListByBaseIdFront', data);
}

export function deviceVideoRelation(query) {
    return request({
        url: '/intelligent/deviceVideoRelation/list', method: 'get', params: query,
    })
}

// 区域治理
export function findAllGunAreaConfig(query) {
    return request({
        url: '/intelligent/gunAreaConfig/findAllGunAreaConfig', methods: 'get', params: query
    });
}

// -------------------鹰眼系统------请求雾炮数据------------------------------------------
export function listType(query) {
    // return request.get('/intelligent/ursDeviceAll/listType?type=' + data);
    return request({
        url: '/intelligent/ursDeviceAll/listType', method: 'get', params: query,
    })
}

// 修改控制方式
export function getmodifyExtension(data) {
    return request.post('/intelligent/device/updateUrsDeviceAllFront', data);
}

// 设备预警查询
export function findDevicealertsConfg(query) {
    return request({
        url: '/intelligent/tbKeyData/findById', method: 'get', params: query,
    })
}

// 企业基本信息查询

export function tenantInfomation(query) {
    return request({
        url: '/intelligent/tenantInfomation/getOneByTenantId', method: 'get', params: query
    })
}

// 企业基本信息修改

export function updtenantInfomation(data) {
    return request({
        url: '/intelligent/tenantInfomation/update', method: 'put', data
    })
}

// 查询用户个人信息
export function getUserProfile() {
    return request({
        url: '/system/user/profile', method: 'get'
    })
}

// 取地图标注与坐标
export function gettakelatlng1(query) {
    // 查询不是区域标记
    // export function getMark(query) {
    return request({
        url: '/intelligent/mapDevice/findDeviceTypeAndIsLabel',
        method: 'get',
        params: query
    })
    // }
}

// 获取tsp,微站最后一次数据
export function gettspwzlastData(query) {
    return request({
        url: '/intelligent/device/findAllLastData', method: 'post', params: query
    })
}

//雾炮运行时长统计图
export function getWupaoOpenDuration(query) {
    return request({
        url: '/intelligent/gunWorkConfig/countStartTimeByType', method: 'get', params: query
    })
}

//雾炮日志
export function tbFogGunlist(query) {
    return request({
        url: '/intelligent/tbFogGun/getCreateTime', method: 'get', params: query
    })
}

// 区域查询
export function deviceLable(query) {
    return request({
        url: '/intelligent/deviceLable/list', method: 'get', params: query
    })
}

// 区域新增
export function savedeviceLable(data) {
    return request({
        url: '/intelligent/deviceLable/save', method: 'post', data
    })
}

// 区域修改

export function upddeviceLable(data) {
    return request({
        url: '/intelligent/deviceLable/update', method: 'put', data
    })
}

// 区域删除
export function deldeviceLable(Id) {
    return request({
        url: '/intelligent/deviceLable/delete/' + Id, method: 'delete',
    })
}

// 修改用户个人信息
export function updateUserProfile(data) {
    return request({
        url: '/system/user/profile', method: 'put', data: data
    })
}

// //区域联系人
// export function deviceLable(query) {
// return request({
// url: '/intelligent/deviceLable/list',
// method: 'get',
// params: query
// })
// }

// // -------------------鹰眼系统----- 预警信息-----提交经办人消息-------
// export function putDealPeo(data) {
// return request({
// url: '/intelligent/ursDeviceAlarmBase/updateLogFrontNew', method: 'put', params: data
// })
// }


// 设备种类统计
export function groupByType(query) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/groupByType', method: 'post', params: query
    })
}

// 风险级别
export function groupByLevel(query) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/groupByLevel', method: 'post', params: query
    })
}

// 类型统计
export function groupByClassification(query) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/groupByClassification', method: 'post', params: query
    })
}

// 查询治理设备本日
export function groupGovernToday(query) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/groupGovernToday', method: 'post', params: query
    })
}

// 查询监测设备每日
export function groupMonitoringToday(query) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/groupMonitoringToday', method: 'post', params: query
    })
}

// 查询治理设备时间段内
export function groupGovernTime(query) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/groupGovernTime', method: 'post', params: query
    })
}

//查询监测设备时间段内
export function groupMonitoringTime(query) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/groupMonitoringTime', method: 'post', params: query
    })
}

// 用户密码重置
export function updateUserPwd(oldPassword, newPassword) {
    const data = {
        oldPassword, newPassword
    }
    return request({
        url: '/system/user/profile/updatePwd', method: 'put', params: data
    })
}

// 用户头像上传
export function uploadAvatar(data) {
    return request({
        url: '/system/user/profile/avatar', method: 'post', data: data
    })
}

//查询是检测设备/预警设备
// 查询字典数据列表
export function listData(query) {
    return request({
        url: '/system/dict/data/list', method: 'get', params: query
    })
}

//预警监测-----------监测预警信息
export function warnInfo(data) {
    return request.get('/intelligent/ursDeviceAlarmBase/pageFront', data);
}

//预警监测-----------治理预警信息
export function getZlwarnInfo(data) {
    return request.get('/intelligent/ursDeviceAlarmBase/pageFrontNew', data);
}

// 用户头像上传
export function dispose(id) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/dispose/' + id,
        method: 'post',
    })
}
// -------------------鹰眼系统----- 预警信息-----查看经办人消息-------
export function getDealPeoInfo(data) {
    return request.get('/intelligent/ursDeviceAlarmBase/getLogFrontNew', data);
}
// -------------------鹰眼系统----- 预警信息-----提交经办人消息-------
export function putDealPeo(data) {
    return request({
        url: '/intelligent/ursDeviceAlarmBase/updateLogFrontNew',
        method: 'put',
        params: data
    })
}

// -----------------------无组织排放---------清扫车查询-------
export function listCleaningTrolley(query) {
    return request({
        url: '/intelligent/cleaningTrolley/listCleaningTrolley',
        method: 'get',
        params: query,
    })
}
// 查询所有设备类型
export function getDeviceTypes(query) {
    return request({
        url: '/intelligent/device/getDeviceTypes',
        method: 'get',
        params: query
    })
}

// 图片模糊处理
export function imageJudge(query) {
    return request({
        url: '/intelligent/imageBlurDetector/imageLearn',
        method: 'get',
        params: query
    })
}


// WEBPACK FOOTER //
// ./src/api/ruoyi.js